module.exports = __webpack_public_path__ + "app/assets/fonts/glyphicons-halflings-regular.ttf?e18bbf611f2a2e43afc071aa2f4e1512";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/glyphicons-halflings-regular.ttf
// module id = 178
// module chunks = 1